const rewardChannelsApi = require('../api/rewardchannels');

const MIN_REWARD_CHANNELS_UPDATE = 1000 * 60 * 60 * 24; // one day
const FETCH_REWARD_CHANNELS_TIMEOUT = 1000 * 30; // 30 seconds

function fetchRewardChannelsInProgress() {
  return {
    type: 'FETCH_REWARD_CHANNELS_IN_PROGRESS',
    timestamp: Date.now(),
  };
}

function fetchRewardChannelsSuccessful(rewardChannels) {
  return {
    type: 'FETCH_REWARD_CHANNELS_SUCCESSFUL',
    rewardChannels,
    timestamp: Date.now(),
  };
}

function fetchRewardChannelsFailed(reason) {
  return {
    type: 'FETCH_REWARD_CHANNELS_FAILED',
    reason,
    timestamp: Date.now(),
  };
}

function fetchRewardChannels() {
  return (dispatch, getState) => {
    dispatch(fetchRewardChannelsInProgress());

    const state = getState();
    const { apiUrl } = state.auth;
    const { token } = state.auth;

    return rewardChannelsApi.fetchRewardChannels(apiUrl, token).then(
      (rewardChannels) => {
        dispatch(fetchRewardChannelsSuccessful(rewardChannels));
        return rewardChannels;
      },
      (error) => {
        dispatch(fetchRewardChannelsFailed(error));
        throw error;
      },
    );
  };
}

function shouldFetchRewardChannels(state, skipOutdatedCheck) {
  const { fetchingInProgressSince, didInvalidate, lastSuccessfulFetch } =
    state.rewardChannels;

  if (!fetchingInProgressSince) {
    // Should update if it was explicetely invalidated
    if (didInvalidate) {
      return true;
    }

    // Should update if data is too old
    if (
      !skipOutdatedCheck &&
      (!lastSuccessfulFetch ||
        Date.now() - lastSuccessfulFetch > MIN_REWARD_CHANNELS_UPDATE)
    ) {
      return true;
    }
  } else if (
    fetchingInProgressSince &&
    Date.now() - fetchingInProgressSince > FETCH_REWARD_CHANNELS_TIMEOUT
  ) {
    // Ensure we cannot get stuck in fetchingInProgressSince=true state.
    return true;
  }

  return false;
}

function fetchRewardChannelsIfNeeded() {
  return (dispatch, getState) => {
    if (shouldFetchRewardChannels(getState())) {
      return dispatch(fetchRewardChannels());
    }
    return Promise.resolve();
  };
}

function invalidateRewardChannels() {
  return {
    type: 'INVALIDATE_REWARD_CHANNELS',
    timestamp: Date.now(),
  };
}

module.exports = {
  fetchRewardChannelsIfNeeded,
  invalidateRewardChannels,
};
